import { render, staticRenderFns } from "./ImportantIcon.vue?vue&type=template&id=6f6ed4f0&functional=true"
import script from "./ImportantIcon.vue?vue&type=script&lang=js"
export * from "./ImportantIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports